import { render, staticRenderFns } from "./AboutUsManage.vue?vue&type=template&id=6ffdfae8&scoped=true"
import script from "./AboutUsManage.vue?vue&type=script&lang=js"
export * from "./AboutUsManage.vue?vue&type=script&lang=js"
import style0 from "./AboutUsManage.vue?vue&type=style&index=0&id=6ffdfae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffdfae8",
  null
  
)

export default component.exports